import {gql} from '@apollo/client/core';

export const UserCartFragment = gql`
  fragment userCart on Cart {
    id
    itemsTotalPrice
    totalPrice
    totalToPayPrice
    totalTax
    itemsTotalQty
    totalPriceBeforeAllDiscount
    appliedCartRuleNames
    itemsTotalBulkDiscount
    totalDiscount
    sameAsBilling
    customerNote
    groupVoucherCode
    isVirtual
    testCases
    flexVouchers {
      code
      balance
      withdrawnBalance
    }
    flexVoucherUsedAmount
    couponCode
    couponDiscountAmount
    preorderDate
    requiredRestrictions
    fulfilledRestrictions
    isEnPrimeur
    cartRules {
      id
      name
      amount
    }
    shippingMethod {
      carrier
      price
      method
      deliveryComment
      deliveryDate
      title
    }
    billingAddress {
      email
      id
      address
      addressCity
      addressZip
      customerId
      country
      countryCode
      companyName
      ean
      cvr
      fullname
      phone
      customerType
      groupVoucherCollectiveDelivery
      lockAddress
      lockAddressCity
      lockAddressZip
      lockCompany
      lockCountry
      lockCvr
      lockEan
      showEAN
    }
    shippingAddress {
      email
      id
      address
      addressCity
      addressZip
      customerId
      country
      countryCode
      companyName
      fullname
      customerType
      groupVoucherCollectiveDelivery
    }
    items {
      id
      vismaId
      name
      price
      priceBeforeDiscount
      isEnPrimeur
      qty
      isFree
      sku
      attributeSet
      productSubType
      salableQty
      stockStatus
      image {
        id
        thumbnail
        small
        large
        original
        width
        height
      }
      unit
      url
      ctaText
      compareAtPrice
      qtyPrice
      qtyPriceBeforeDiscount
      title
      preorderDate
    }
    cartId
  }
`;
